















import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import { getQueryVariable } from '../common/common';
import OriginalTextMark from '../components/OriginalTextMark.vue';
import ReportHeader from '../components/ReportHeader.vue';
import ReportFooter from '../components/ReportFooter.vue';
import CheckInfo from '../components/CheckInfo.vue';
import CheckResult from '../components/CheckResult.vue';
import CheckLimit from '../components/CheckLimit.vue';
import CheckResultDetail from '../components/CheckResultDetail.vue';
import SimilarList from '../components/SimilarList.vue';
import SimilarListChart from '../components/SimilarListChart.vue';
import SimilarListDetails from '../components/SimilarListDetails.vue';
import Explain from '../components/Explain.vue';

export default Vue.extend({
  name: 'DetailPart',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText,
  }),
  components: {
    OriginalTextMark,
    ReportHeader,
    ReportFooter,
    CheckInfo,
    CheckResult,
    CheckLimit,
    CheckResultDetail,
    SimilarList,
    SimilarListChart,
    SimilarListDetails,
    Explain
  },
  data() {
    return {
    };
  },
  methods: {
    // 获取检测报告数据
    getData() {
      if (JSON.stringify(this.checkInfo) === '{}') {
        this.$store.dispatch('setCheckInfo');
      }
      if (!this.checkText) {
        this.$store.dispatch('setCheckText');
      }
    }
  },
  mounted() {
    this.getData();
  }
});
